import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import ApiConection from 'api_ref/ApiConection';
import { ConvertDateToText, DisplayPaging } from "components/MyControl";
import { useNavigate } from "react-router-dom";
import { Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import UtilClass from "api_ref/UtilClass";

export default function MenuCustomer() {
    const nav = useNavigate();
    const api = new ApiConection();
    const util = new UtilClass();
    const [filterDispaly, setFilterDisplay] = useState(false);
    const [loading, setLoading] = useState(false);

    const [dataTable, setDataTable] = useState({
        arr_table: [],
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    })
    const [search, setSearch] = useState({
        login_name: '',
        user_group_id: '',
        first_name: '',
        last_name: '',
        show_name: '',
        email: '',
        tel: '',
        active: '',
        is_approved:'',
        page: util.getCombinedSessionStorage('/menucustomer','page') ?? 1,
        size: util.getCombinedSessionStorage('/menucustomer','size') ?? 10
    })

    const callAipUsers = async () => {
        let data = {
            search: {
            },
            pagination: {
                page: search.page,
                size: search.size
            }
        }

        if (search.login_name != '')
            data.search.login_name = search.login_name;
        if (search.first_name != '')
            data.search.first_name = search.first_name;
        if (search.last_name != '')
            data.search.last_name = search.last_name;
        if (search.show_name != '')
            data.search.show_name = search.show_name;
        if (search.email != '')
            data.search.email = search.email;
        if (search.tel != '')
            data.search.tel = search.tel;
        if (search.active != '')
            data.search.active = (search.active == true || search.active == 'true');
        if (search.is_approved != '')
            data.search.is_approved = (search.is_approved == true || search.is_approved == 'true');

        setLoading(true);

        const response_pagination = await api.postData('api/UsersCustomer/Pagination', data);
        if (response_pagination.status === true) {
            handleSetDataTable('record_start', response_pagination.data.record_start);
            handleSetDataTable('record_count', response_pagination.data.record_count);
            handleSetDataTable('page_count', response_pagination.data.page_count);
        }

        const response_result = await api.postData(`api/UsersCustomer/result`, data);
        if (response_result.status == true) {
            handleSetDataTable('arr_table', response_result.data);
        } else {
            handleSetDataTable('arr_table', []);
        }

        let record_end = response_pagination.data.record_start + (search.size - 1);
            if (record_end > response_pagination.data.record_count) {
                record_end = response_pagination.data.record_count;
            }

            handleSetDataTable('record_end', record_end);

            setLoading(false);
    }

    const handleSetDataTable = (name, value) => {
        setDataTable(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;

        util.setCombinedSessionStorage('/menucustomer','page',1);
        util.setCombinedSessionStorage('/menucustomer','size',value);

        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }

    const handlePagingChange = (page_no) => {

        util.setCombinedSessionStorage('/menucustomer','page',page_no);

        handleSetSearch('page', page_no);
    }

    const handleQuickSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch('login_name', value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleFullSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch(name, value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                callAipUsers();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search])

    const handleDetail = (id) => {
        nav(`/menucustomer/edit/${id}`);
    }
    const handleCreate = () => {
        nav('/menucustomer/create')
    }

    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <div className={Css.Header}>
                                <div className="d-flex">
                                    <h6 className="d-flex align-items-center">จัดการผู้ใช้สำหรับลูกค้า</h6>
                                    <div className="flex-fill">
                                        <Form.Group as={Row}>
                                            <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                                            <Col>
                                                <InputGroup>
                                                    <Form.Control placeholder="ค้นหาที่นี่" id={'txtQuickSearch'} value={search.login_name}
                                                        disabled={filterDispaly}
                                                        onChange={(event) => handleQuickSearch(event)} />
                                                    <Button variant="outline-secondary" onClick={event => setFilterDisplay(!filterDispaly)}>
                                                        {
                                                            filterDispaly === true &&
                                                            <i className="fa-solid fa-arrow-up-short-wide"></i>
                                                        }
                                                        {
                                                            filterDispaly === false &&
                                                            <i className="fa-solid fa-arrow-down-short-wide"></i>
                                                        }
                                                        <span></span>
                                                    </Button>
                                                    <Button>
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </Button>
                                                </InputGroup>

                                            </Col>
                                        </Form.Group>

                                    </div>
                                </div>
                                {
                                    filterDispaly === true &&
                                    <div className="d-flex bg-">
                                        <div className="w-100 bg-light p-3">
                                            <Row className="mb-2">
                                                <Col>
                                                    <Form.Label>ชื่อบัญชี</Form.Label>
                                                    <Form.Control name={'login_name'} value={search.login_name} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>ชื่อ</Form.Label>
                                                    <Form.Control name={'first_name'} value={search.first_name} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>นามสกุล</Form.Label>
                                                    <Form.Control name={'last_name'} value={search.last_name} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>ชื่อที่แสดง</Form.Label>
                                                    <Form.Control name={'show_name'} value={search.show_name} onChange={handleFullSearch} />
                                                </Col>
                                            </Row>
                                            <Row className="mb-2">
                                                <Col>
                                                    <Form.Label>อีเมล</Form.Label>
                                                    <Form.Control name={'email'} value={search.email} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>เบอร์โทรศัพท์</Form.Label>
                                                    <Form.Control name={'tel'} value={search.tel} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                <Form.Label>สถานะ</Form.Label>
                                                    <Form.Select name={'active'} value={search.active} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                <Form.Label>สถานะ Approved</Form.Label>
                                                    <Form.Select name={'is_approved'} value={search.is_approved} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={Css.Content + ' position-relative'}>
                                {
                                    loading &&
                                    <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className={Css.Content + ' position-relative'}>
                                    <Button variant="outline-success" className="d-flex justify-content-center" onClick={event => handleCreate()}>
                                        <i className="fa-solid fa-plus me-2 mt-1"></i>เพิ่มบัญชีผู้ใช้
                                    </Button>
                                </div>

                                <div className="table-responsive border rounded">

                                    <table className="table text-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th ></th>
                                                <th>#</th>
                                                <th className="text-start" >ชื่อบัญชี</th>
                                                <th className="text-start" >ชื่อ</th>
                                                <th className="text-start" >นามสกุล</th>
                                                <th>ชื่อที่แสดง</th>
                                                <th>อีเมล</th>
                                                <th>เบอร์โทรศัพท์</th>
                                                <th>สิทธิ์ผู้ใช้</th>
                                                <th>วันที่สร้าง</th>
                                                <th>วันที่แก้ไข</th>
                                                <th>แก้ไขโดย</th>
                                                <th>สถานะ</th>
                                                <th>Approved</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataTable.arr_table.length > 0 &&
                                                dataTable.arr_table.map((obj, index) =>{
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <button className="btn btn-edit-icon" onClick={event => handleDetail(obj.id)} >
                                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                                </button>
                                                            </td>
                                                            <td>{dataTable.record_start + index}</td>
                                                            <td className="text-start">{obj.login_name}</td>
                                                            <td className="text-start">{obj.first_name}</td>
                                                            <td className="text-start">{obj.last_name}</td>
                                                            <td className="text-start">{obj.show_name}</td>
                                                            <td className="text-start">{obj.email}</td>
                                                            <td className="text-start">{obj.tel}</td>
                                                            <td className="text-start">{obj.user_group_name}</td>
                                                            <td>{ConvertDateToText(obj.create_date)}</td>
                                                            <td>{ConvertDateToText(obj.modify_date)}</td>
                                                            <td className="text-start">{obj.modify_by}</td>
                                                            <td>{obj.active == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}</td>
                                                            <td>{obj.is_approved == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <DisplayPaging rec_start={dataTable.record_start}
                                    rec_end={dataTable.record_end}
                                    rec_count={dataTable.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={dataTable.page_count}
                                    onPagingChange={handlePagingChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}